import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { BUCKET_FILTER, MULTISELECT_FILTER, LINK_FILTER, FilterItemType, } from '@as-react/common-types';
import { Checkbox, Link, RadioButton, Stack, TextAlpha } from '@yonderland/andes-react';
import { FILTER_SIZE_SEPARATOR } from '../../../../constants/GeneralConstants';
import { HtmlInclude } from '../../../common/html-include/HtmlInclude';
export const FiltersSizeItem = ({ item, type, filter, toggleFilterValue, desktop, search }) => {
    const { pageInfo, canonicalUrl } = useAemConfig();
    const isBrandFilter = filter.filterOn === 'brand' && (pageInfo.isBrandPage || pageInfo.isCategoryPage);
    const baseUrl = canonicalUrl.slice(0, canonicalUrl.indexOf('.html'));
    const filterName = item.name.split(FILTER_SIZE_SEPARATOR)[0];
    let url = '';
    let filterItemType;
    switch (type) {
        case BUCKET_FILTER:
            filterItemType = FilterItemType.SINGLE;
            break;
        case LINK_FILTER:
            filterItemType = FilterItemType.LINK;
            break;
        case MULTISELECT_FILTER:
        default:
            filterItemType = FilterItemType.MULTI;
    }
    if (isBrandFilter && !!item.normalizedName) {
        url = `${baseUrl}/${item.normalizedName}.html`;
    }
    else if (type === LINK_FILTER) {
        const urlObj = new URL(canonicalUrl);
        urlObj.searchParams.set(filter.queryParamKey, `${filter.filterOn}:${item.filterKey}`);
        url = urlObj.toString();
    }
    const getLabelChildren = (active, search) => url ? (_jsx(Link, { href: url, title: filterName, onClick: handleLinkClick, children: getFilterLabel(active, search) })) : (getFilterLabel(active, search));
    const getFilterLabel = (active, search) => (_jsxs(Stack, { gap: "2", align: "center", wrap: "nowrap", children: [_jsx(TextAlpha, { strong: active, as: "span", children: search ? (_jsx(HtmlInclude, { htmlFragment: filterName.replace(new RegExp(`(${search})`, 'i'), '<strong>$1</strong>') })) : (filterName) }), typeof item.itemCount === 'number' ? (_jsxs(TextAlpha, { as: "span", color: "subtle", children: ["(", item.itemCount, ")"] })) : null] }));
    const handleLinkClick = (e) => {
        var _a;
        if (e) {
            e.preventDefault();
            (_a = e.currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    const handleClick = (event) => toggleFilterValue(event, item);
    const handleChange = (event) => toggleFilterValue(event, item);
    const id = `${item.filterKey}-${filter.filterOn}`;
    return (_jsxs(_Fragment, { children: [filterItemType === FilterItemType.MULTI && (_jsx(Checkbox, { id: id, name: item.normalizedName, value: item.filterKey, checked: item.active, onChange: handleChange, label: getLabelChildren(item.active, search) })), filterItemType === FilterItemType.SINGLE && (_jsx(RadioButton, { id: id, name: desktop ? `${filter.filterOn}-desktop` : filter.filterOn, value: item.filterKey, checked: item.active, onChange: handleChange, label: getLabelChildren(item.active, search) })), filterItemType === FilterItemType.LINK && (_jsx(Link, { href: url, title: filterName, onClick: handleClick, children: getFilterLabel(item.active) }))] }));
};
